/* eslint-disable no-nested-ternary */
import { Form, InputNumber } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useIsExactChecked } from '@core/offices/actions/properties/filterActions';
import { FilterComponentInput } from '@core/offices/types';

import { ExactCheckbox } from './exact-checkbox';

const FilterInputNumber = (props: FilterComponentInput) => {
  const { t } = useTranslation();
  const { valuePrefix } = useIsExactChecked(props.filter);
  return (
    <Form.Item
      rules={[
        {
          type: 'number',
          min: props.filter.minValue ?? 0,
          max: props.filter.maxValue ?? 1000,
          message: t('filters.validation.numberRange', {
            min: props.filter.minValue ?? '0',
            max: props.filter.maxValue ?? '1000',
          }),
        },
      ]}
      label={props.filter.label}
      initialValue={props.value}
    >
      <InputNumber
        min={props.filter.minValue ?? 0}
        max={props.filter.maxValue ?? 1000}
        className="w-full rounded-3xl"
        prefix={props.value ? valuePrefix : undefined}
        prefixCls="bg-transparent"
        value={props.value}
        type="number"
        {...props}
        onChange={(e) => props.handleChange(e)}
      />
      <ExactCheckbox filter={props.filter} />
    </Form.Item>
  );
};
export default FilterInputNumber;
